import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "counter" }

import { computed, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { Mutations } from '@/store';
import { getISOWeek } from 'date-fns';
import { PurchaseType } from '@/models/purchase.model';
import { formatPrice } from '@/core/filters';
import CurrencyUtil from '@/core/services/CurrencyUtil';
import PurchaseList from '@/components/purchases/PurchaseList.vue';
import CountDown from '@/components/countdown/CountDown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PurchaseView',
  setup(__props) {

const store = useStore();
const route = useRoute();
const purchaseTotal = computed<number>(() => store.getters.purchaseTotal);

const AMOUNT_PER_WEEK = 3.5;
const amount = ref<number>(0);

const pocketMoney = computed<number>(() =>
  store.state.purchaseType === PurchaseType.Hardware ? 0 : amount.value,
);
const amountPerWeek = computed<string>(
  () => ` at ${CurrencyUtil.formatPrice(AMOUNT_PER_WEEK)} per week`,
);

const update = () => {
  const year = parseInt(`${route.params.year}`, 10);
  const d = new Date();
  const currentYear = d.getUTCFullYear();
  let week = getISOWeek(d);

  store.commit(Mutations.SetYear, year);

  // count all weeks if the year is in the past;
  if (currentYear > year) {
    week = 52;
  } else if (currentYear < year) {
    week = 0;
  }

  amount.value = AMOUNT_PER_WEEK * week;
};

onMounted(update);

watch(route, update, { deep: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(CountDown, {
      value: _unref(formatPrice)(_unref(pocketMoney) - _unref(purchaseTotal)),
      title: _unref(amountPerWeek)
    }, null, 8, ["value", "title"]),
    _createVNode(PurchaseList)
  ]))
}
}

})